import { uniqueById } from '../helpers';

export default function shapeSets(state = [], action) {
  switch(action.type) {
    case 'UPDATE_GLOBAL_SHAPESETS':
      return uniqueById(action.shapeSets);

    case 'LOGOUT':
      return [];

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/shapeSets.js